import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { makeRequest } from "../axios";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(
    JSON.parse(localStorage.getItem("user")) || null
  );

  const login = async (inputs) => {
    const res = await makeRequest.post("/auth/login", inputs, {
      withCredentials: true,
    });

    setCurrentUser(res.data)
  };

  const register = async (inputs) => {
    const res = await makeRequest.post("/auth/register", inputs, {
      withCredentials: true,
    });

    setCurrentUser(res.data)
  };

  const Otpverify = async (inputs) => {
    const res = await makeRequest.post("/auth/Otpverify", inputs, {
      withCredentials: true,
    });

    
  };

  const passr = async (inputs) => {
    const res = await makeRequest.post("/auth/passr", inputs, {
      withCredentials: true,
    });

    
  };

  const passrest = async (inputs) => {
    const res = await makeRequest.post("/auth/passrest", inputs, {
      withCredentials: true,
    });

    
  };

  const passupdate = async (inputs) => {
    const res = await makeRequest.post("/auth/passupdate", inputs, {
      withCredentials: true,
    });

    
  };

  const passupdate1 = async (inputs) => {
    const res = await makeRequest.post("/auth/passupdate1", inputs, {
      withCredentials: true,
    });

    
  };


  const logout = async (inputs) => {
    const res = await makeRequest.post("auth/logout",{
      withCredentials: true,
    });

    if (localStorage.getItem("user")) {
      localStorage.removeItem("user");
      console.log("user logged out.");
    } else {
      console.log("Item does not exist.");
    }

  };



  useEffect(() => {
    localStorage.setItem("user", JSON.stringify(currentUser));
  }, [currentUser]);

  return (
    <AuthContext.Provider value={{ currentUser, login,logout, register,Otpverify,passr,passrest,passupdate,passupdate1}}>
      {children}
    </AuthContext.Provider>
  );
};
